import RadialProgressChart from './radial-progress-chart';
import './styles.styl';

export default RadialProgressChart;
